import AreaService from "@/api/services/finanzas/nomencladores/AreaService"
import Vue from "vue"

const state = () => ({
    areas: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    AREAS: state => {
        return state.areas
    },
    AREAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_AREAS: (state, payload) => {
        state.areas = payload
    },

    SET_AREAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_AREA: (state, payload) => {
        state.areas.push(payload)
    },

    UPDATE_AREA: (state, payload) => {
        state.areas = state.areas.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_AREA: (state, payload) => {
        state.areas = state.areas.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_AREAS: async ({ commit, state }, { filter, areaEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await AreaService.get({ filter, areaEstado, ...pagination })
            if (status === 200) {
                commit("SET_AREAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las áreas del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_AREAS: async ({ commit }) => {
        try {
            let { data, status } = await AreaService.getAll()
            if (status === 200) {
                commit("SET_AREAS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_AREAS: async ({ commit }) => {
        try {
            let { data, status } = await AreaService.getAllRecords()
            if (status === 200) {
                commit("SET_AREAS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las áreas del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_AREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AreaService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_AREA", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial para el área del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_AREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AreaService.post(payload)
            if (status === 201) {
                commit("ADD_AREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El área del activo ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el área del activo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_AREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AreaService.put(payload)
            if (status === 200) {
                commit("UPDATE_AREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El área del activo ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el área del activo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_AREA: async ({ commit }, payload) => {
        try {
            let { status, data } = await AreaService.delete(payload)
            if (status === 204) {
                commit("DELETE_AREA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El área del activo ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_AREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El área del activo ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el área del activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
